// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2IOZr","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Ydkq"};